import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging'; // Import Messaging, getToken, onMessage
import { AngularFireMessaging } from '@angular/fire/compat/messaging'; // For AngularFire 7+ using compat for consistency
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  private vapidKey: string = 'BBXkDyVGSyNybGVKmnw72YlI-P0Vfio9KmOdCnFH4YQ94b7ty2Cl9mM2v0vA2lRIqyrqryQ_Qm2JumAHoqZ-rmc';
  constructor(
    private afMessaging: AngularFireMessaging, 
    private messaging: Messaging,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  requestPermissionAndGetToken() {
    // Skip on server - Firebase messaging requires browser APIs
    if (!this.isBrowser()) {
      return;
    }

    // Request permission from the user
    this.afMessaging.requestToken
      .subscribe(
        (token) => {
          // console.log('Permission granted and token received:', token);
          // localStorage.setItem('deviceToken', token);
          // localStorage.setItem('deviceToken', "BBXkDyVGSyNybGVKmnw72YlI-P0Vfio9KmOdCnFH4YQ94b7ty2Cl9mM2v0vA2lRIqyrqryQ_Qm2JumAHoqZ-rmc");
          // Send this token to your backend server for sending push notifications
          // You might store it in a database associated with the user
        },
        (error) => {
          // localStorage.setItem('deviceToken', "BBXkDyVGSyNybGVKmnw72YlI-P0Vfio9KmOdCnFH4YQ94b7ty2Cl9mM2v0vA2lRIqyrqryQ_Qm2JumAHoqZ-rmc");
          // console.error('Permission denied or error getting token:', error);
        }
      );
  }

  listenForMessages() {
    // Skip on server - Firebase messaging requires browser APIs
    if (!this.isBrowser()) {
      return;
    }

    // Listen for incoming messages while the app is in the foreground
    this.afMessaging.messages.subscribe((message) => {
      // console.log('Foreground message received:', message);
      
    });
  }

  // Alternative way to get the token using the direct Firebase SDK (useful if you prefer less @angular/fire abstraction)
  async getTokenDirectly() {
    // Skip on server - Firebase messaging requires browser APIs
    if (!this.isBrowser()) {
      return;
    }

    try {
      const currentToken = await getToken(this.messaging, { vapidKey: this.vapidKey }); // Use injected messaging
      if (currentToken) {
        // console.log('Current device token (direct):', currentToken);
        // Send to your server
      } else {
        // console.log('No registration token available. Request permission to generate one.');
      }
    } catch (err) {
      // console.error('An error occurred while retrieving token (direct):', err);
    }
  }

  // Example of listening for messages directly using the Messaging instance
  listenForMessagesDirectly() {
    // Skip on server - Firebase messaging requires browser APIs
    if (!this.isBrowser()) {
      return;
    }

    onMessage(this.messaging, (payload) => {
      // console.log('Foreground message received (direct):', payload);
      // Handle the message here
    });
  }
}